import { render, staticRenderFns } from "./ProfileStudent.vue?vue&type=template&id=0e7e2398&scoped=true&"
import script from "./ProfileStudent.vue?vue&type=script&lang=ts&"
export * from "./ProfileStudent.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileStudent.vue?vue&type=style&index=0&id=0e7e2398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e2398",
  null
  
)

export default component.exports